const buildFilter = (entity, projectId, search) => {
  return {
    conjunction: 'All',
    projectId,
    entity,
    predicates: search
      ? [
          {
            attribute: 'Search',
            operator: 'Contains',
            values: [search]
          }
        ]
      : []
  }
}

export const pinsSearchFilter = (projectId, search) =>
  buildFilter('Pins', projectId, search)

export const tasksSearchFilter = (projectId, search) =>
  buildFilter('Tasks', projectId, search)
